module.exports = __webpack_public_path__ + "b7ba0f364e9517d187d7e6d15434e4ec.pdf";